import { css } from 'react-emotion';

const styles = {
	lineStyles: css`
		font-size: 16px;
		border-radius: 2px;
		margin-bottom: 2px;
		padding: 8px 24px;
		background-color: #f7f7f7;
		word-break: break-word;
	`,

	headerRow: css`
		font-size: 16px;
		border-radius: 2px;
		margin-bottom: 2px;
		padding: 8px 24px;
		background-color: white;
	`,
	payments__container: css`
		background: white;
		padding: 1rem;
	`,
	main__description: css`
		display: block;
		font-size: 0.75rem;
		line-height: 1.5;
		margin: 0.25rem 0;
	`,
};

export default styles;
